import {Component, Vue} from 'vue-property-decorator';
import { cloneDeep } from 'lodash';

export interface TabMeta {
  icon?: string;
  title?: string;
}

export interface TabMetaBase extends TabMeta {
  inheritIcon?: string;
}

@Component
export default class MainMenuComplexTabsMetaMixin extends Vue {
  get customKeys() {
    return Array.apply(null, {length: 10} as any)
      .map((value, index) => `custom${index + 1}Name`);
  }

  get customtabsMetaBase(): { [type: string]: TabMetaBase } {
    let result: { [type: string]: TabMetaBase } = {
      'custom': {
        icon: 'fas fa-cogs'
      }
    };

    this.customKeys.forEach((item, index) => {
      const key = `custom${index + 1}`;
      result[key] = {
        inheritIcon: 'custom'
      }
    });

    return result;
  }

  get tabsMetaBase(): { [type: string]: TabMetaBase }  {
    return {
      'countries': {
        icon: 'fa fa-globe-europe',
        title: this.t('Countries')
      },
      'languages': {
        inheritIcon: 'countries',
        title: this.t('Languages')
      },
      'cities': {
        inheritIcon: 'countries',
        title: this.t('Cities')
      },
      'states': {
        inheritIcon: 'countries',
        title: this.t('State / Region')
      },
      'isps': {
        icon: 'fa fa-wifi',
        title: this.t('ISP')
      },
      'mobile-carriers': {
        inheritIcon: 'isps',
        title: this.t('Mobile Carriers')
      },
      'connection-types': {
        inheritIcon: 'isps',
        title: this.t('Connection Types')
      },
      'ips': {
        icon: 'fas fa-exchange-alt',
        title: this.t('IPs')
      },
      'subnet-small': {
        inheritIcon: 'ips',
        title: this.t('Subnets (Small)')
      },
      'subnet-big': {
        inheritIcon: 'ips',
        title: this.t('Subnets (Big)')
      },
      'devices': {
        icon: 'fa fa-laptop',
        title: this.t('Devices')
      },
      'device-models': {
        inheritIcon: 'devices',
        title: 'Device Models'
      },
      'device-vendors': {
        inheritIcon: 'devices',
        title: this.t('Device Vendors')
      },
      'device-types': {
        inheritIcon: 'devices',
        title: this.t('Device Types')
      },
      'screen-resolutions': {
        inheritIcon: 'devices',
        title: this.t('Screen Resolutions')
      },
      'oses': {
        icon: 'fa fa-mobile',
        title: this.t('OS')
      },
      'os-versions': {
        inheritIcon: 'oses',
        title: this.t('OS Versions')
      },
      'browsers': {
        icon: 'fas fa-browser',
        title: this.t('Browsers')
      },
      'browser-versions': {
        inheritIcon: 'browsers',
        title: this.t('Browser Versions')
      },
      'useragents': {
        inheritIcon: 'browsers',
        title: this.t('User Agents')
      },
      'referrers': {
        icon: 'fas fa-compass',
        title: this.t('Referrers')
      },
      'referrer-domains': {
        inheritIcon: 'referrers',
        title: this.t('Referrer Domains')
      },
      'lives': {
        icon: 'fas fa-wave-square',
        title: this.t('Live Visits')
      },
      'period': {
        icon: 'far fa-clock',
        title: this.t('Period')
      },
      'month': {
        inheritIcon: 'period',
        title: this.t('Month')
      },
      'day': {
        inheritIcon: 'period',
        title: this.t('Day of Month')
      },
      'day-of-week': {
        inheritIcon: 'period',
        title: this.t('Day Of Week')
      },
      'hour-of-day': {
        inheritIcon: 'period',
        title: this.t('Hour Of Day')
      },
      'campaigns': {
        icon: 'fa fa-bullseye-arrow',
        title: this.t('Campaigns')
      },
      'offers': {
        icon: 'fa fa-badge-dollar',
        title: this.t('Offers')
      },
      'landings': {
        icon: 'fa fa-browser',
        title: this.t('Landings')
      },
      'flows': {
        icon: 'fas fa-sitemap',
        title: this.t('Flows')
      },
      'traffic-sources': {
        icon: 'fa fa-globe',
        title: this.t('Traffic Sources')
      },
      'affiliate-networks': {
        icon: 'fa fa-users-class',
        title: this.t('Affiliate Networks')
      },
      'conversions': {
        icon: 'fas fa-dollar-sign',
        title: this.t('Conversions')
      },
      'postbacks': {
        icon: 'fa fa-download',
        title: this.t('Postbacks')
      },
      'errors': {
        icon: 'fa fa-exclamation-circle',
        title: this.t('Errors')
      },
      'flow_rule_paths': {
        title: this.t('Flow path'),
        icon: 'fa fa-exclamation-circle',
      },
      'flow_rules': {
        title: this.t('Flow rule'),
        icon: 'fa fa-exclamation-circle'
      },
      ...this.customtabsMetaBase
    };
  }

  get tabsMeta(): { [type: string]: TabMeta }  {
    const tabsMetaBase = cloneDeep(this.tabsMetaBase);
    const keys = Object.keys(tabsMetaBase);
    let result: { [type: string]: TabMetaBase } = {};

    keys.forEach((key) => {
      const item = tabsMetaBase[key];
      if(item.inheritIcon) {
        item.icon = tabsMetaBase[item.inheritIcon].icon;
        delete item.inheritIcon;
      }
      
      result[key] = item;
    });

    return result;
  }
}
